import { z } from 'zod';

export const FilterValueSchema = z.object({
  id: z.string(),
  label: z.string(),
});

export type FilterValue = z.infer<typeof FilterValueSchema>;

export const FilterSchema = z.object({
  id: z.string(),
  label: z.string(),
  values: z.array(FilterValueSchema),
});

export type Filter = z.infer<typeof FilterSchema>;

export const FiltersSchema = z.object({
  array: FilterSchema.optional(),
  node: FilterSchema.optional(),
  container: FilterSchema.optional(),
  bank: FilterSchema.optional(),
  pack: FilterSchema.optional(),
  module: FilterSchema.optional(),
});

export type Filters = z.infer<typeof FiltersSchema>;

export const SelectedFiltersSchema = z.object({
  arrayId: z.string().optional(),
  nodeId: z.string().optional(),
  containerId: z.string().optional(),
  bankId: z.string().optional(),
  packId: z.string().optional(),
  moduleId: z.string().optional(),
});

export type SelectedFilters = z.infer<typeof SelectedFiltersSchema>;
